<template>
  <Modal title="添加基本法到当前机构" v-model="visible" width="460" class="my-modal" :mask-closable="false"
    :footer-hide="true">
    <Form ref="form" :model="formData" class="page-form" label-position="left">
      <FormItem prop="baseId" label="基本法名称" :rules="$units.formRule.required('请选择')" class="full">
        <Select v-model="formData.baseId" placeholder="请选择" filterable>
          <Option v-for="(item, i) in dataList" :value="item.id" :key="i">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="startTime" label="开始日期" :rules="$units.formRule.objRequired('请选择')" class="full">
        <DatePicker transfer type="date" v-model="formData.startTime" format="yyyy-MM-dd" placeholder="请选择"
          :options="dateOptions"></DatePicker>
      </FormItem>
      <FormItem prop="endTime" label="结束日期" :rules="$units.formRule.objRequired('请选择')" class="full">
        <DatePicker transfer type="date" v-model="formData.endTime" format="yyyy-MM-dd" placeholder="请选择"
          :options="dateOptions"></DatePicker>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        id: "",
        startTime: "",
        endTime: "",
        baseId:''
      },
      dataList: [],
      dateOptions: {
        disabledDate: (date) => {
          return date && date.valueOf() < Date.now()
        },
      },
    };
  },
  watch: {},
  computed: {
  },
  created() { },
  mounted() {

  },
  methods: {
    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        formData.startTime = this.$units.formatDate(formData.startTime);
        formData.endTime = this.$units.formatDate(formData.endTime);
        if (formData.startTime > formData.endTime) {
          return this.$notice.error("基本法开始时间不能大于结束时间");
        }
        if(formData.orgId){
          formData.orgIds = [formData.orgId]
          delete formData.orgId;
        }
        this.$http({
          type: "POST",
          url: "/buz/baseAssign/add",
          data: formData
        }).then(res => {
          this.$emit('success')
          this.visible = false;
        })
      })
    },
    open(data) {
      this.visible = true;
      this.$refs.form && this.$refs.form.resetFields();
      console.log('--------', data)
      this.formData.orgId = data.id
      this.getDataList();
    },
    // 获取基本法数据
    getDataList() {
      this.$http({
        type: "GET",
        url: "/buz/baseMethod/queryByMechan",
        data: {}
      }).then(res => {
        this.dataList = res.data;
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.my-modal /deep/ .ivu-select-item {
  font-size: 12px !important;
}
</style>